import { render, staticRenderFns } from "./inquirydetail.vue?vue&type=template&id=3a71020e&scoped=true"
import script from "./inquirydetail.vue?vue&type=script&lang=js"
export * from "./inquirydetail.vue?vue&type=script&lang=js"
import style0 from "./inquirydetail.vue?vue&type=style&index=0&id=3a71020e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71020e",
  null
  
)

export default component.exports